/**
 * @voltxampere/ui — P-channel MOSFET (PMOS)
 *
 * Same dashed-channel pattern as NMOS, plus the inverter "bubble"
 * (small open circle) on the gate side at (12, 13). The body line
 * shifts to x=13.5 to make room for the bubble. Per §1.3, source
 * sits at top-right (32, 3), drain at bottom-right (32, 23). The
 * canonical bubble stroke is 1.1; clamped to 1.3 here.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_DETAIL, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const pmos = {
    id: "pmos",
    nameTr: "PMOS",
    nameEn: "P-MOSFET",
    shortcut: "⇧M",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "G", polarity: "in" },
        { x: 32, y: 3, label: "S", polarity: "in" },
        { x: 32, y: 23, label: "D", polarity: "out" },
    ],
    defaultLabel: "M",
    renderSVG: () => [
        `<circle cx="12" cy="13" r="1.6" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_DETAIL)}"/>`,
        `<line x1="13.5" y1="5" x2="13.5" y2="21" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="17" y1="5" x2="17" y2="10" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="17" y1="16" x2="17" y2="21" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="17" y1="10" x2="17" y2="16" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}" stroke-dasharray="1.5,1.5"/>`,
        `<line x1="0" y1="13" x2="10" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="17" y1="8" x2="27" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="27" y1="3" x2="32" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="17" y1="18" x2="27" y2="23" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="27" y1="23" x2="32" y2="23" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=pmos.js.map